module.exports = __webpack_public_path__ + "static/og-preview-728e91b7bbe4b8cf8cf84fa4434c50bb.png";